import { useRouter } from 'next/router';
import { useState } from 'react';

import { getCoordinate } from '@/parsers/f2f/common';
import { UserCoordinate } from '@/types/hospital';
import { PharmacySearchParamsQueries, PharmacySearchQueries } from '@/types/pharmacy';
import { updateSearchParams } from '@/utils/url';

import useToast from '../useToast';

const useWebLocation = () => {
  const router = useRouter();
  const [dongLiName, setDongLiName] = useState('');
  const { showToast } = useToast();

  const { latitude, longitude } = router.query as PharmacySearchQueries;
  const currentLocation = getCoordinate(latitude, longitude);

  const updateSearchParamsLocation = ({ latitude, longitude }: UserCoordinate) => {
    updateSearchParams([
      {
        key: PharmacySearchParamsQueries.Latitude,
        value: latitude,
      },
      {
        key: PharmacySearchParamsQueries.Longitude,
        value: longitude,
      },
    ]);
  };
  const requestGeolocationPermissionInWeb = async (
    callback?: ({ latitude, longitude }: UserCoordinate) => void,
    isToast = false
  ) => {
    if (!navigator.geolocation) {
      return;
    }

    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        updateSearchParamsLocation({
          latitude: coords.latitude,
          longitude: coords.longitude,
        });

        callback &&
          callback({
            latitude: coords.latitude,
            longitude: coords.longitude,
          });
      },
      () => {
        if (!isToast) return;
        showToast({
          message: '위치 권한 허용 후 다시 시도해주세요',
        });
      },
      { enableHighAccuracy: false, timeout: 7000 }
    );
  };

  const updateDongLiName = (currentDongLiName: string) => {
    setDongLiName(currentDongLiName);
  };

  return {
    dongLiName,
    currentLocation,
    updateDongLiName,
    requestGeolocationPermissionInWeb,
  };
};

export default useWebLocation;
